import React, { useEffect, useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { cn } from '../lib/utils';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Як працюємо',
    href: '#how-it-works'
  }, {
    name: 'Ціни',
    href: '#pricing'
  }, {
    name: 'Відгуки',
    href: '#testimonials'
  }, {
    name: 'Контакти',
    href: '#footer'
  }];
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b', isScrolled ? 'bg-white/90 backdrop-blur-md border-gray-200 py-3' : 'bg-transparent border-transparent py-5')} data-id="element-109">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-110">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-111">
          <div className="w-8 h-8 bg-black text-white flex items-center justify-center font-display font-bold text-lg" data-id="element-112">
            R
          </div>
          <span className="font-display font-semibold text-xl tracking-tight hidden sm:block" data-id="element-113">
            Recovery<span className="text-gray-400" data-id="element-114">Clinic</span>
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-115">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-black transition-colors" data-id="element-116">
              {link.name}
            </a>)}
        </nav>

        {/* Right Actions */}
        <div className="flex items-center gap-4" data-id="element-117">
          <div className="hidden md:flex items-center gap-2 mr-2" data-id="element-118">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse-slow" data-id="element-119" />
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-120">
              Працюємо 24/7
            </span>
          </div>

          <a href="tel:+380000000000" className="flex items-center gap-2 font-medium hover:opacity-70 transition-opacity" data-id="element-121">
            <Phone className="w-4 h-4" strokeWidth={2} data-id="element-122" />
            <span className="hidden sm:inline" data-id="element-123">0 800 00 00 00</span>
          </a>

          <Button className="hidden md:inline-flex" data-id="element-124">Викликати лікаря</Button>

          <button className="lg:hidden p-2 -mr-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-125">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-126" /> : <Menu className="w-6 h-6" data-id="element-127" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white border-b border-gray-200 p-4 flex flex-col gap-4 lg:hidden shadow-lg" data-id="element-128">
          <div className="flex items-center gap-2 mb-2" data-id="element-129">
            <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-130" />
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-131">
              Працюємо 24/7
            </span>
          </div>
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium py-2 border-b border-gray-100" onClick={() => setMobileMenuOpen(false)} data-id="element-132">
              {link.name}
            </a>)}
          <Button className="w-full mt-4" size="lg" data-id="element-133">
            Викликати лікаря
          </Button>
        </div>}
    </header>;
};